import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Title, Content } from "../Components/Typo";
import { HashLink } from "react-router-hash-link";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  cursor: all-scroll;
`;

const Description = styled.div`
  color: #000;
  width: 50vw;
  height: 100vh;
  background-color: #fff;
  border-bottom: 1px solid #000;
  padding-left: 50px;
  padding-right: 50px;
`;

const Illustration = styled.div`
  width: 50vw;
  background-image: ${(props) => `url("${props.url}")`};
  background-position: center;
  background-size: cover;
  object-fit: cover;
  object-position: center top;
  background-position: center;
  height: 100vh;
`;

const TitleStyled = styled(Title)`
  text-align: center;
  margin-top: 60px;
`;
const Center = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Button = styled(HashLink)`
  cursor: pointer;
  justify-self: center;
  width: 250px;
  border-radius: 25px;
  margin-top: 15px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  border: 2px solid #000;
  backdrop-filter: blur(15px);
  color: #000;
  transition: all 0.5s;
  :hover {
    background-color: #000;
    color: #fff;
  }
`;

export default function Exploration() {
  const { t } = useTranslation();
  return (
    <>
      <Container>
        <Illustration url="spatial1.jpg" />
        <Description>
          <TitleStyled>Motivations for space activity</TitleStyled>
          <Content>
            Since 1957 Earth-orbiting satellites and robotic spacecraft
            journeying away from Earth have gathered valuable data about the
            Sun, Earth, other bodies in the solar system, and the universe
            beyond. Robotic spacecraft have landed on the Moon, Venus, Mars,
            Titan, a comet, and four asteroids, have visited all the major
            planets, and have flown by Kuiper belt objects and by the nuclei of
            comets, including Halley’s Comet, traveling in the inner solar
            system. Scientists have used space-derived data to deepen human
            understanding of the origin and evolution of galaxies, stars,
            planets, and other cosmological phenomena.
          </Content>
          <Center>
            <Button
              onClick={() => {
                document.getElementById("spatial").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "center",
                });
              }}
            >
              {t("next")}
            </Button>
          </Center>
        </Description>
      </Container>
      <Container id="spatial">
        <Illustration url="spatial2.jpg" />
        <Description>
          <TitleStyled>
            Les accomplissements de l'homme dans l'espace
          </TitleStyled>
          <Content>
            Since 1957 Earth-orbiting satellites and robotic spacecraft
            journeying away from Earth have gathered valuable data about the
            Sun, Earth, other bodies in the solar system, and the universe
            beyond. Robotic spacecraft have landed on the Moon, Venus, Mars,
            Titan, a comet, and four asteroids, have visited all the major
            planets, and have flown by Kuiper belt objects and by the nuclei of
            comets, including Halley’s Comet, traveling in the inner solar
            system. Scientists have used space-derived data to deepen human
            understanding of the origin and evolution of galaxies, stars,
            planets, and other cosmological phenomena.
          </Content>
          <Center>
            <Button to={"/human#earth"}>{t("next")}</Button>
          </Center>
        </Description>
      </Container>
    </>
  );
}
